import React from 'react';
import Icon from './Icon';
import { colors } from '../theme/colors';

const DateRangePicker = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div className="flex items-center gap-2">
        {/* <Icon name="calendar" size={20} color={colors.primary[600]} /> */}
        <span className="text-sm font-medium text-gray-700">Période :</span>
      </div>
      
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <label className="text-xs text-gray-500 whitespace-nowrap">Du</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent w-full sm:w-auto"
          />
        </div>
        
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <label className="text-xs text-gray-500 whitespace-nowrap">Au</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            min={startDate}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent w-full sm:w-auto"
          />
        </div>

        {(startDate || endDate) && (
          <button
            onClick={() => {
              onStartDateChange('');
              onEndDateChange('');
            }}
            className="text-gray-400 hover:text-red-600 transition-colors p-1"
            title="Réinitialiser"
          >
            <Icon name="close" size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;